import arrayReduce from "./component-library416.mjs";
import deburr from "./component-library417.mjs";
import words from "./component-library418.mjs";
var rsApos = "['’]";
var reApos = RegExp(rsApos, "g");
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
  };
}
export {
  createCompounder as default
};
